import { cn } from '@/utils/cn';
import Spinner from '../atoms/Spinner';

type IndicatorType =
	| 'totalTrainings'
	| 'unmappedPositions'
	| 'unmappedTrainings';

const getTextColorByValueAndType = (type: IndicatorType, value?: number) => {
	if (type === 'unmappedPositions' || type === 'unmappedTrainings') {
		return value && value > 0 ? 'text-red' : 'text-[#008000]';
	}
	return 'text-primary';
};

const getTitleByType = (type: IndicatorType) => {
	switch (type) {
		case 'totalTrainings':
			return 'Treinamentos cadastrados';
		case 'unmappedPositions':
			return 'Funções não mapeadas';
		case 'unmappedTrainings':
			return 'Treinamentos não mapeados';
		default:
			return '';
	}
};

export const NewRegulatoryTrainingLinkIndicator = ({
	type,
	value,
	isLoading,
	selected,
	onClick,
}: {
	type: IndicatorType;
	value?: number;
	isLoading: boolean;
	selected?: boolean;
	onClick?: () => void;
}) => {
	const title = getTitleByType(type);
	const textColor = getTextColorByValueAndType(type, value);
	return (
		<button
			type="button"
			className={cn(
				'flex flex-col gap-1  justify-center items-start rounded-md p-2  h-20 bg-white w-60 text-lg',
				selected && 'border-[1px] border-red',
				!onClick && 'cursor-default',
			)}
			onClick={onClick}
			disabled={!onClick || isLoading || !value}
		>
			<h5 className="text-sm text-gray-500 font-semibold">{title}</h5>
			{isLoading ? (
				<Spinner size={20} />
			) : (
				<span className={cn('text-[20px] font-bold', textColor)}>{value}</span>
			)}
		</button>
	);
};
